export const ROUTES = {
  BASE: {
    path: '/'
  },
  PLANT_SELECTOR: {
    path: '/plants',
    PLANT: {
      path: ':plantCode'
    }
  },
  NOT_AUTHORIZED: {
    path: '/403'
  },
  NOT_FOUND: {
    path: '/404'
  }
}
